import { Collapse, Table, Tag, Typography } from "antd";
import moment from "moment";
import React from "react";
import { buildProgressRows, getProgressSummary } from "./vaccinationProgress";
import "./VaccinationProgressByType.css";

const { Panel } = Collapse;
const { Text } = Typography;

const columns = [
  {
    title: "No",
    key: "no",
    width: 60,
    render: (_, __, index) => <span>{index + 1}</span>,
  },
  {
    title: "Tanggal",
    dataIndex: "date_taken",
    key: "date_taken",
    width: 140,
    render: (text) => (
      <span>{text ? moment(text).format("DD/MM/YYYY") : "-"}</span>
    ),
  },
  {
    title: "Vaksin",
    dataIndex: "vaccine_name",
    key: "vaccine_name",
    render: (text, record) =>
      record.kind === "overlap" ? (
        <Tag color="gold">Dosis dari {text || "vaksin lain"}</Tag>
      ) : (
        <span>{text || "-"}</span>
      ),
  },
  {
    title: "Batch",
    dataIndex: "batch",
    key: "batch",
    render: (text) => <span>{text || "-"}</span>,
  },
  {
    title: "Keterangan",
    dataIndex: "note",
    key: "note",
    render: (text) => <span>{text || "-"}</span>,
  },
];

const PanelHeader = ({ type, summary }) => (
  <div className="vaccination-progress-header">
    <Text strong>{type?.name || "-"}</Text>
    <span className="vaccination-progress-header-right">
      {summary.isOverSchedule && (
        <Text type="secondary">
          Jadwal standar: {summary.defaultFrequency} dosis
        </Text>
      )}
      <Tag color={summary.isComplete ? "green" : "blue"}>
        {summary.countFinish} / {summary.frequency} dosis
      </Tag>
    </span>
  </div>
);

// Progres vaksinasi per tipe vaksin dari child.vaccinationsByType.
const VaccinationProgressByType = ({ vaccinationsByType }) => {
  const types = Array.isArray(vaccinationsByType) ? vaccinationsByType : [];

  if (!types.length) {
    return <Text type="secondary">Belum ada data progres vaksinasi.</Text>;
  }

  const summaries = types.map(getProgressSummary);

  // Tipe yang punya dosis lintas-vaksin atau melebihi jadwal standar langsung terbuka
  const defaultActiveKey = types
    .map((type, index) => ({ type, summary: summaries[index], index }))
    .filter(({ summary }) => summary.hasOverlap || summary.isOverSchedule)
    .map(({ type, index }) => type?.id ?? index);

  return (
    <Collapse
      className="vaccination-progress"
      defaultActiveKey={defaultActiveKey}
    >
      {types.map((type, index) => {
        const rows = buildProgressRows(type);
        return (
          <Panel
            key={type?.id ?? index}
            header={<PanelHeader type={type} summary={summaries[index]} />}
          >
            <Table
              size="small"
              dataSource={rows}
              columns={columns}
              pagination={false}
              rowClassName={(record) =>
                record.kind === "overlap" ? "vaccination-progress-overlap" : ""
              }
              locale={{ emptyText: "Belum ada dosis" }}
            />
          </Panel>
        );
      })}
    </Collapse>
  );
};

export default VaccinationProgressByType;
